import SearchIcon from "@mui/icons-material/Search";
import { Box, InputAdornment, TextField } from "@mui/material";
import { FC, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import classes from "./search.styles";

type Props = {
  onSearch: (search: string) => void;
  size?: "normal" | "small";
};

export const Search: FC<Props> = ({ onSearch, size = "normal" }) => {
  const [searchParams] = useSearchParams();

  const [search, setSearch] = useState(searchParams.get("search") || "");

  const debounced = useDebouncedCallback((value) => {
    onSearch(value);
  }, 500);

  const clearSearch = () => {
    setSearch("");
    onSearch("");
  };

  return (
    <TextField
      variant="outlined"
      value={search}
      sx={classes[size]}
      onChange={(event) => {
        setSearch(event.target.value);
        debounced(event.target.value);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ color: "text.secondary" }}>
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="start">
            <Box
              sx={{
                ...classes.clear,
                visibility: search ? "visible" : "hidden",
              }}
              onClick={clearSearch}
            >
              &times;
            </Box>
          </InputAdornment>
        ),
      }}
    />
  );
};
